module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/en/6-ae556ef0cfc3ea4cdd364596cd497b32.jpg";